import './card.scss';

export function CardTail() {
  return <div className="card-internal__tail" />;
}
